// Adapted from React Bits Blur Text for the site's headings:
// https://reactbits.dev/text-animations/blur-text
import { useEffect, useRef, useState } from 'react';
import './BlurText.css';

export default function BlurText({ text, className = '', delay = 0 }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const units = /[\u3400-\u9fff]/.test(text)
    ? Array.from(text)
    : text.split(/(\s+)/).filter(Boolean);
  let characterIndex = 0;

  useEffect(() => {
    if (
      typeof IntersectionObserver === 'undefined' ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        setVisible(true);
        observer.disconnect();
      },
      { threshold: 0.15 },
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <span
      ref={ref}
      className={`blur-text${visible ? ' is-visible' : ''}${className ? ` ${className}` : ''}`}
    >
      <span className="blur-text__sr-only">{text}</span>
      {units.map((unit, unitIndex) => {
        if (/^\s+$/.test(unit))
          return (
            <span key={`space-${unitIndex}`} aria-hidden="true">
              {' '}
            </span>
          );
        return (
          <span className="blur-text__unit" key={`unit-${unitIndex}`} aria-hidden="true">
            {Array.from(unit).map((character) => {
              const index = characterIndex++;
              return (
                <span
                  key={`${character}-${index}`}
                  className="blur-text__character"
                  style={{ '--character-delay': `${delay + Math.min(index * 32, 500)}ms` }}
                >
                  {character}
                </span>
              );
            })}
          </span>
        );
      })}
    </span>
  );
}
